import { useTranslation } from 'next-i18next'

import { useRef } from 'react'

import { useAppDispatch } from '~/redux/hooks'
import HamburgerIcon from '~/components/Icons/svgs/HamburgerIcon'
import ResponsiveImage from '~/components/Image/ResponsiveImage'
import { closeMenu } from '~/redux/slices/menu'
import MenuOverlay from '~/menu/components/MenuOverlay'
import useClickOutside from '~/shared/hooks/useClickOutside.hook'

import { setMenuCurriculumDropdownExpandedActionCreator } from '~/curriculum/slice/curriculum.slice'

import useHandleAndLogToggleMenu from '../hooks/useHandleAndLogToggleMenu'

const mediaQuery = [{ screen: '(min-width: 1024px)', width: '52px' }]

const HamburgerMenu = ({ isDonationLayout = false }): React.ReactElement => {
  const { t } = useTranslation(['homebase', 'imageAlt'])
  const dispatch = useAppDispatch()
  const ref = useRef<HTMLDivElement>(null)
  const onCLickHandler = useHandleAndLogToggleMenu()

  useClickOutside(ref, () => {
    dispatch(closeMenu())
    dispatch(setMenuCurriculumDropdownExpandedActionCreator(false))
  })

  if (isDonationLayout) {
    return (
      <div className="flex flex-col items-center" ref={ref}>
        <button
          className="w-7 md:w-9 lg:w-13 -ml-1.5 md:-ml-0 mr-2 md:mr-4"
          data-test-id="menu-hamburger"
          onClick={onCLickHandler}
        >
          <ResponsiveImage
            alt={t('imageAlt:icons.menu')}
            height={44}
            imageClassName="w-7 md:w-9 lg:w-13"
            imageWidths="80, 100"
            loading="eager"
            mediaQuery={mediaQuery}
            srcKey="icons/burger-menu-desktop.png"
            width={52}
          />
        </button>
        <span className="-ml-3 -mb-0.5 lg:mb-0 lg:-mt-1 text-2 md:text-2.5 leading-3 font-medium text-white text-center">
          {t('menuLabel')}
        </span>
        <MenuOverlay isDonationLayout={isDonationLayout} />
      </div>
    )
  }

  return (
    <div className="flex order-2 md:order-none flex-col items-center" ref={ref}>
      <button
        aria-label={t('imageAlt:icons.menu')}
        className="flex w-9 h-9 items-center justify-center rounded-2.5 bg-white-dim"
        data-test-id="menu-hamburger"
        onClick={onCLickHandler}
      >
        <HamburgerIcon className="w-6 h-6" pathClassName="text-white" />
      </button>
      <MenuOverlay isDonationLayout={isDonationLayout} />
    </div>
  )
}

export default HamburgerMenu
